import { type FunctionComponent, useRef, useState } from 'react';
import { handleCarouselMobileSwipe, onLeftButtonClick, onRightButtonClick } from '../../../../helpers/carousel/carousel.helper';
import { CarouselButtonsWithCount } from '../../../carousel-components/carousel-buttons-with-count/carousel-buttons-with-count.component';
import { HomeShopByLookPanel } from '../common/shop-by-look-panel.component';
import { ShopByLookSlide, ShopByLookImageSlide } from '../common/shop-by-look-slide.component';
import { cardSliderContent, imageSliderContainer, transitionStyle, textSliderContainer } from './shop-by-look.css';
import { type HomeShopByLookSizedProps } from './shop-by-look.types';

export const HomeShopByLookSmall: FunctionComponent<HomeShopByLookSizedProps> = ({ className, slides }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [prevTouchMoveValue, setPrevTouchMoveValue] = useState(0);
	const [translateValuePercentageCard, setTranslateValuePercentageCard] = useState(0);

	// Mobile touch event refs
	const touchStartXRef = useRef<number>(0);
	const touchMoveXRef = useRef<number>(0);
	const sliderContainerRef = useRef<HTMLDivElement>(null);

	return (
		<>
			<div className={`${className} chromatic-ignore`} data-testid="home-shop-by-look-small">
				<HomeShopByLookPanel />
				{/* ImageSlider */}
				<div
					className={`relative overflow-hidden flex flex-row items-end w-100 overflow-x-hidden relative ${imageSliderContainer}`}>
					<div
						className={`flex h-100 ${transitionStyle}`}
						ref={sliderContainerRef}
						onTouchStart={(e) => (touchStartXRef.current = e.targetTouches[0].clientX)}
						onTouchMove={(e) => (touchMoveXRef.current = e.targetTouches[0].clientX)}
						onTouchEnd={() =>
							handleCarouselMobileSwipe(
								setTranslateValuePercentageCard,
								setActiveIndex,
								setPrevTouchMoveValue,
								prevTouchMoveValue,
								touchStartXRef.current,
								touchMoveXRef.current,
								activeIndex,
								slides.length - 1
							)
						}
						style={{
							transform: `translate(${translateValuePercentageCard}%)`,
							scrollBehavior: 'smooth',
							touchAction: 'pan-y'
						}}
						data-testid="shop-by-look-small-image-slider">
						{slides.map((slide, index) => (
							<div className={`flex ${cardSliderContent}`} key={`${slide.title}-${index}`}>
								<ShopByLookSlide item={slide} SlideContent={ShopByLookImageSlide} />
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="flex flex-column items-center justify-between w-100">
				<CarouselButtonsWithCount
					onLeftButtonClick={() => onLeftButtonClick(setTranslateValuePercentageCard, setActiveIndex, activeIndex)}
					onRightButtonClick={() => onRightButtonClick(setTranslateValuePercentageCard, setActiveIndex, activeIndex)}
					activeIndex={activeIndex}
					totalItems={slides.length}
					className="pa3 theme-black justify-end"
				/>
				{/* TextSlider */}
				<div className={`overflow-hidden ${textSliderContainer}`}>
					<div
						className={`flex h-100 ${transitionStyle}`}
						ref={sliderContainerRef}
						onTouchStart={(e) => (touchStartXRef.current = e.targetTouches[0].clientX)}
						onTouchMove={(e) => (touchMoveXRef.current = e.targetTouches[0].clientX)}
						onTouchEnd={() =>
							handleCarouselMobileSwipe(
								setTranslateValuePercentageCard,
								setActiveIndex,
								setPrevTouchMoveValue,
								prevTouchMoveValue,
								touchStartXRef.current,
								touchMoveXRef.current,
								activeIndex,
								slides.length - 1
							)
						}
						style={{
							transform: `translate(${translateValuePercentageCard}%)`,
							scrollBehavior: 'smooth',
							touchAction: 'pan-y'
						}}
						data-testid="shop-by-look-small-text-slider">
						{slides.map((slide, index) => (
							<div className={`flex ${cardSliderContent}`} key={`${slide.title}-${index}`}>
								<ShopByLookSlide item={slide} slideContentClass="items-center lh-copy pa4" />
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};
